// ServiceHero.js
import React from 'react';
import { Link } from 'react-router-dom';

const ServiceHero = ({ breadcrumbs, title, description }) => {
  return (
    <section className="bg-cream pt-16 pb-16 md:pt-24 md:pb-20">
      <div className="max-w-5xl mx-auto px-6 text-center">
        {/* Breadcrumb */}
        <div className="flex items-center justify-center gap-2 text-sm text-muted mb-8">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span className="text-line">|</span>}
              {crumb.link ? (
                <Link to={crumb.link} className="hover:text-primary transition-colors">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-ink">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>

        <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
          Home Care Services
        </p>
        <h1 className="font-display font-light text-ink leading-[1.1] text-4xl md:text-5xl mb-5">
          {title}
        </h1>
        <p className="text-muted text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          {description}
        </p>
      </div>
    </section>
  );
};

export default ServiceHero;
